import ReactPaginate from 'react-paginate';

export interface ListPaginationProps {
  page: number;
  itemsCount: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

export const ListPagination = ({ page, itemsCount, itemsPerPage, onPageChange }: ListPaginationProps) => {
  if (!itemsCount || !itemsPerPage) return null;

  const pageCount = Math.ceil(itemsCount / itemsPerPage);

  const handlePageClick = (event: { selected: number }) => {
    onPageChange(event.selected + 1);
  };

  return (
    <div className="d-flex justify-content-center">
      <div className="mt-4">
        <ReactPaginate
          nextLabel=" > "
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          forcePage={page ? page - 1 : 0}
          previousLabel=" < "
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={undefined}
        />
      </div>
    </div>
  );
};
